module.exports = __webpack_public_path__ + "static/media/format_bold.8628daf3.svg";